"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerificationServiceLive = void 0;
const HttpProvider_1 = require("../utils/HttpProvider");
const constants_1 = require("../utils/constants");
class VerificationServiceLive {
    async sendEmail() {
        const response = await HttpProvider_1.httpProvider.post(constants_1.SEND_EMAIL, {});
        return response.data.status;
    }
    async verifyEmail(verificationToken) {
        await HttpProvider_1.httpProvider.get(verificationToken);
        return null;
    }
    async checkKycStatus(checkKycStatusData) {
        if (checkKycStatusData) {
            return true;
        }
        return false;
    }
    async sendEmailVerificationCode(sendEmailOtpData) {
        const response = await HttpProvider_1.httpProvider.post(constants_1.SEND_EMAIL_OTP, {
            ...sendEmailOtpData,
        });
        return response.data;
    }
    async verifyEmailWithCode(verifyEmailOtpData) {
        const response = await HttpProvider_1.httpProvider.post(constants_1.VERIFY_EMAIL_OTP, {
            ...verifyEmailOtpData,
        });
        if (!response?.data?.status) {
            const message = (typeof response?.data?.message === "string" && response.data.message) ||
                "An error occurred while verifying the email code";
            throw new Error(message);
        }
        return true;
    }
}
exports.VerificationServiceLive = VerificationServiceLive;
//# sourceMappingURL=VerificationServiceLive.js.map